import { setCredentials } from "../store/slice/auth.slice";
import { fetchAdminDataByEmail } from ".";

export const setupAuthListener = async (dispatch: any) => {
  try {
    const data = await fetchAdminDataByEmail();

    if (data && data?.id) {
      localStorage.setItem("__Iplot_admin_access_", data?.id);
      dispatch(
        setCredentials({
          access_token: data?.id,
        })
      );
    } else {
      localStorage.removeItem("__Iplot_admin_access_");
    }
  } catch (err) {
    console.error("Error refreshing token:", err);
    localStorage.removeItem("__Iplot_admin_access_");
    window.location.href = "/login";
  }
};
